/**
 * IS THE AIRCRAFT DOWN — one answer, read from the provider's own word.
 *
 * Its own module because both the welcome screen and the hook that polls for it need it,
 * and a component importing a status rule from another component is how two copies start.
 *
 * ── ⚠️ `Arrived` IS THE WORD, AND IT IS THE ONLY ONE THAT MEANS DOWN ───────────────
 * AeroDataBox's own vocabulary, confirmed against a live YYZ arrivals feed on 2026-09-16:
 * of the flights that had landed, 61 of 61 read `Arrived`, and none said "Landed". Before
 * that a flight reads `Expected`, `EnRoute` or `Delayed`.
 *
 * `Landed` is matched as well, at no cost, against a provider that words it differently.
 *
 * ── ⚠️ NULL IS "NOT KNOWN", NEVER "NOT LANDED" ────────────────────────────────────
 * A lookup that has not returned, or one that failed, has no status. Callers decide what
 * to do with that — this only answers when there IS a word to read.
 */

const ARRIVED_STATUSES = new Set(['arrived', 'landed'])

export function isFlightArrived(flight) {
    const status = flight?.status
    return typeof status === 'string' && ARRIVED_STATUSES.has(status.trim().toLowerCase())
}

export default isFlightArrived
